import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";

export default function AuthenticationLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 bg-surface">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
